<div class="container-tab-lists nxtdc">
    <div class="inner-tcontainer-tab">
        <div style="position:relative">
            <div class="deployment-info">
                <h2 class="flex-aligned-div" (click)="openDeploymentInformationPopup()">
                    Deployment information
                    <mat-icon data-html="true" class="info-icon">info</mat-icon>
                </h2>
            </div>
            <div class="tab-body">
                <div class="tab-content">
                    <mat-tab-group #tabGroup (selectedTabChange)="defaults.updateComponentTab($event.tab.textLabel)" mat-stretch-tabs="false">
                        <mat-tab label="Manufacturing Center Product" *ngIf="defaults.isMFGAdminPDCSUser || defaults.isMFGAdminCenterUser">
                            <manufacturingcenterproduct #manufacturingCenterProductComponent (centerProductEvent)="loadCenterProduct($event)"
                                                        [availableProductUsages]="availableProductUsages"
                                                        [availableCenters]="availableCenters"></manufacturingcenterproduct>
                        </mat-tab>

                        <mat-tab label="Product Usage" *ngIf="defaults.isMFGAdminPDCSUser">
                            <productusage #productUsageComponent (productUsageEvent)="loadProductUsage($event)"></productusage>
                        </mat-tab>

                        <mat-tab label="Manufacturing Line Versions" *ngIf="defaults.isMFGAdminPDCSUser || defaults.isMFGAdminCenterUser">
                            <sfwversionconfiggeneration #sfwVersionConfigGenerationComponent [availableCenterProducts]="availableCenterProducts"
                                                        [availableControllerSoftwareReleases]="originalSoftwareReleases"
                                                        [availableCenters]="availableCenters"></sfwversionconfiggeneration>
                        </mat-tab>

                        <mat-tab label="JCoB Rules" *ngIf="defaults.isMFGAdminPDCSUser">
                            <filemasterdata [originalMfgCenterProduct]="originalMfgCenterProduct"
                                            [originalSoftwareReleases]="originalSoftwareReleases"></filemasterdata>
                        </mat-tab>

                    </mat-tab-group>
                </div>
            </div>
        </div>
    </div>
</div>